export default "<h3>Source Control Management Settings</h3>\n<app-api-gateway-settings></app-api-gateway-settings>\n"